import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import App from './App';
import { initializeFirebase } from './firebase/config';
import { preloadAppImages } from './utils/imagePreloader';

async function initializeApp() {
  try {
    // Precargar imágenes
    preloadAppImages();

    await initializeFirebase();

    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Error al inicializar la aplicación:', error);
  }
}

initializeApp();